import SignersDropdown from 'hellospa/components/editor/signers-dropdown';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPreviewSigner } from './data/actions';
import { selectPreviewCurrentSigner, selectPreviewSigners } from './data/selectors';
import { trackHeapCustomEvent } from 'common/utils/heap';

type Props = {
  className?: string,
}
export function PreviewSignersDropdown({ className }: Props) {
  const dispatch = useDispatch();
  const currentSigner = useSelector(selectPreviewCurrentSigner);
  const signers = useSelector(selectPreviewSigners);

  return (
    <SignersDropdown
      onChange={(signerId) => {
        dispatch(setPreviewSigner(signerId));
        trackHeapCustomEvent('Signer View Toggle', {});
      }}
      className={className}
      signers={signers}
      selectedSignerId={currentSigner ? currentSigner.id : undefined}
      selectedSignerName={currentSigner ? currentSigner.name : undefined}
      shouldAddAllSigners={true}
      wrapperDataQaRef={'preview-dropdown'}
      buttonDataQaRef={'preview-dropdown-button'} />
  );
}
